import { Auth } from 'aws-amplify';
import axios, { AxiosInstance } from 'axios';
import { logoutUserAction } from 'src/store';
import { RootState, store } from 'src/store/store';

let apiInstance: AxiosInstance;

function setupAxiosInstance(apiUrl: string): void {
  apiInstance = axios.create({
    baseURL: apiUrl + '/api/v1',
    headers: {
      Accept: 'application/json',
    },
  });

  apiInstance.interceptors.request.use(async (config:any) => {
    // const state: RootState = store.getState();
    // const token = state.user.data.token;
    const data = await Auth.currentSession();
    const idToken: string = data.getIdToken().getJwtToken();
    if (idToken) {
      config.headers?.set?.('Authorization', `Bearer ${idToken}`);
    }
    return config;
  });

  apiInstance.interceptors.response.use(
    (response:any) => response,
    (error:any) => {
      console.error('!!!!Error from API', error);

      // if (error.code === 'ERR_NETWORK') {
      //   window.location.reload();
      // }

      // TODO: remove when 401 redirect is fixed
      if (error?.response?.status === 401) {
        // window.location.reload();
        store.dispatch(logoutUserAction());
        console.log(error.message);
      }

      return Promise.reject(error);
    },
  );
}

export { apiInstance, setupAxiosInstance };
